export default {"src":"https://cdn-assets.dzcdn.net/www/_next/static/media/favicon.da2c7d49.ico","height":36,"width":36,"blurWidth":0,"blurHeight":0};